var en_us = {
  Video_CONFERENCE_HOME_NAME: "263Vision",
  Video_CONFERENCE_MEETING_NAME: "'s meeting",
  JOINING_ROOM: "Joining ",
  PLEACE_INPUT_NAME: "Your name",
  PLEACE_INPUT_ID: "Meeting ID",
  LOGIN_FAILER_INFO_ABOUT_ACCOUNT: "Incorrect username or password.",
  LOGIN_FAILER_INFO_ABOUT_NET:
    "Failed to join. Verify your network connectivity and try again.",
  LOGIN_FAILER_INFO_ABOUT_OTHER: "Failed to login, please try agina later.",
  LOGIN_FAILER_INFO_INVALIED:
    "The login information has changed, please login again",
  LOGIN_PLACEHOLDER_ACCOUNT: "Username",
  LOGIN_PLACEHOLDER_PASSWORD: "Password",
  LOGIN_PLACEHOLDER_PARCITIPANT_NAME: "Your name",
  LOGIN_PLACEHOLDER_ROOMEID: "Meeting ID",
  LOGIN_FAILER_INFO_ROOMEID_ISNOTEXIT: "The meeting ID is not valid.",
  LOGIN_FAILER_INFO_JOINROOMFAILE: "Failed to join, please try again later.",
  LOGIN_NAME: "Log In",
  ADMINER_LOGIN_NAME: "Administrator",
  CLOSE_NAME: "Close",
  PARTICIPATE_MEET: "Quick Start",
  LOGIN_FOOTER_NAME: "Copyright © 1998-2020 北京二六三企业通信有限公司",
  LOGOUT_INFO:
    "You have logged in on another device, and this device has been logged out.",
  USERINFO_IS_DELETED: "Your account has been deleted or disabled.",
  LOGIN_INFO_CHANNGE:
    "The login information has changed, please join the meeting again.",
  SPONSOR_MEET: "Start meeting",
  HOST_MYSELF_MEET: "Host myself meeting",
  PARTICIPATE_OTHERS_MEET: "Join other meeting",
  PARTICIPATE_OTHERS_MEET_PLACEHOLDER: "Meeting ID",
  JOIN_ROOM: "Join",
  JOIN_ROOM_LOADING_NAME: "Joining the meeting",
  JOIN_ROOM_FAILER_NET:
    "Failed to join. Verify your network connectivity and try again.",
  JOIN_ROOM_FAILER_OTHER: "Failed to join, please try again later.",
  JOIN_ROOM_FAILER_ROOMID: "The meeting ID is not valid.",
  JOIN_ROOM_RESUME_LOADING: "'Retrying to enter the meeting …",
  JOIN_ROOM_RESUME_NET_LOADING: "Loading...",
  NET_ONLINE_TIPS: "Reconnecting...",
  NET_OFF_TIPSLINE: "'Network unavailable.",
  FAILED_NAME: "Fail",
  CANCEL_NAME: "Cancel",
  CONFIRM_NAME: "OK",
  UP_ONE_STEP: "Back",
  TIPS_NAME: "Note",
  KOWM_NAME: "I know",
  REMIND_NAME: "Remind",
  REJECT_NAME: "Reject",
  ANSWER_NAME: "Answer",
  HANGUP_NAME: "Hang Up",
  EXIT_NAME: "Exit",
  LOCAL_NAME: "Local",
  MEET_NAME: "Video",
  SHARE_NAME: "Share",
  RELOGIN_NAME: "Re-Login",
  EXIT_LOGIN: "Log Out",
  EXIT_LOGIN_CONFIRM: "Log out now?",
  INVITE_JOIN_TIPSINFO: " invite you to join a meeting.",
  SET_NAME: "Settings",
  DEVICE_INFO: "Device",
  MIC_NAME: "Microphone",
  UNMIC_NAME: "No microphone detected.",
  LOADSPEAKER_NAME: "Speaker",
  CAMERA_NAME: "Camera",
  UNCAMERA_NAME: "No camera detected.",
  MUTE_NAME: "Mute",
  UNMUTE_NAME: "Unmute",
  NO_NAME: "Nothing has been found.",
  UN_USEFUL: "Disable",
  NO_CAMERA: "No camera detected.",
  AUDIO_TEST: "Test",
  STOP_AUDIO_TEST: "Stop",
  SET_MEETING: "Meeting Settings",
  VIDEO_QUALITY: "Video sending quality",
  SHARE_QUALITY: "Share sending quality",
  VIDEO_SEND_RESOLUTION: "Video sending resolution",
  AUTO_NAME: "Auto",
  QUALITY_PRIOR: "Quality Priority",
  FLUENT_PRIOR: "Fluency Priority",
  JOIN_ROOM_MSG_TIPS: "New participant reminder",
  EXIT_ROOM_MSG_TIPS: "Participant leave reminder",
  MEETCHAT_MSG_TIPS: "Chat message reminder",
  ACCOUNT_NAME: "Account",
  SHOW_NAME: "Name",
  ABOUT_NAME: "About",
  BETA_INFO: "Beta  v1.0.0",
  ROOM_MUTE: "Mute All",
  ROOM_UNMUTE: "Unmute All",
  MEET_CONTROL_TIPS_ROOM_MUTE: "The meeting has been muted.",
  MEET_CONTROL_TIPS_ROOM_UNMUTE: "The meeting has been unmuted.",
  MEET_CONTROL_TIPS_AUDIO_CLOSE: "Audio off",
  MEET_CONTROL_TIPS_AUDIO_OPEN: "Audio on",
  MEET_CONTROL_TIPS_VIDEO_CLOSE: "Video off",
  MEET_CONTROL_TIPS_VIDEO_OPEN: "Video on",
  MEET_CONTROL_TIPS_RECORD_OPEN: "Start Recording",
  MEET_CONTROL_TIPS_RECORD_STOP:
    'Stop  Recording?&#10;<span style="color:#999;display: inherit;">After stopping, you can download the recording from the meeting details.</span>',
  MEET_CONTROL_TIPS_RECORD_OPEN_FAILED: "Failed to start recording.",
  MEET_CONTROL_TIPS_RECORD_CLOSE: "This recording has been stopped.",
  MEET_CONTROL_TIPS_RECORD_CLOSE_FAILED: "Failed to stop the recording.",
  STOP_RECORD: "Stop Recording",
  MEET_CONTROL_TIPS_ROOM_MUTE_HOST: "The meeting is muted by the host.",
  MEET_CONTROL_TIPS_ROOM_UNMUTE_HOST: "The meeting is unmuted by the host.",
  MEET_MUTE_FAILED: "Failed to mute all.",
  MEET_UNMUTE_FAILED: "Failed to unmute all.",
  MUTE_CLOSE_FAILED: "Failed to mute.",
  MUTE_OPEN_FAILED: "Failed to unmute.",
  MEET_CONTROL_TIPS_AUDIO_CLOSE_HOST: "You are muted by the host.",
  MEET_CONTROL_TIPS_AUDIO_OPEN_HOST: "You are unmuted by the host.",
  RECORD_OPEN: "Recording has been started.",
  RECORD_CLOSE: "Recording has been stopped.",
  MEET_CONTROL_RECORDING: "The meeting is being recorded.",
  HOST_LEAVE_MEET_TIPS:
    "When leaving the meeting, it is recommended that you transfer the host's role from the participant list to others. To end the meeting, click End Meeting directly.",
  PARTICIPATE_LEAVE_MEET_TIPS: "Are you sure you want to leave the meeting?",
  EXIT_MEET_NAME: "Leave",
  PLEASE_OUT_MEET: "Expel",
  LEAVE_MEET_NAME: "Leave Meeting",
  OVER_MEET_NAME: "End Meeting",
  DESKTOP_SHARE_NAME: "Screen Share",
  PARTICIPATE_NAME: "Participants",
  MEET_CONTROL_NAME: "Manage Paticipants",
  FULL_SCREEN_NAME: "Full Screen",
  EXIT_FULL_SCREEN_NAME: "Exit Full Screen",
  CLEAR_SCREEN_NAME: "Clear Screen",
  CLEAR_SCREEN_TIPS: "Are you sure you want to clear all my marks?",
  OTHER_SHARE_TIPS:
    "is sharing now. If you start a new share, the last one will be stopped.",
  SOMEBODY_ISSHAREIN: " is sharing",
  SELF_SHAREING: "You are sharing.",
  JOINING_NAME: "You are already in meeting.",
  EXIT_CURRENT_CONFERENCE:
    "You have a meeting that is currently in-progress. Please leave it to join a new meeting.",
  LOGIN_OUT_OTHER_POINT:
    "You have joined the meeting on another device. Do you want to kick it off and use this device to join the meeting?",
  OTHER_POINT_JOIN_ROOM:
    "You're already in the meeting on another device, and you have left the meeting here.",
  GOON_SHARE: "Go on",
  OVER_SHARE: "Stop",
  GIVEUP_SHARE: "Give up",
  FORBID_SHARE: "Prohibit Sharing",
  EMPOWER_SHARE: "Allow Sharing",
  SHARE_TIPS_NAME: "In Sharing",
  SHARE_APPLY_NAME: "Apply for Sharing",
  SHARE_APPLY_POWER_TIPS:
    "Sharing is prohibited in the meeting. Do you want to apply for permission?",
  SHARE_APPLY_PART_POWER_TIPS:
    "Your sharing is prohibited by the host. Do you want to apply for permission?",
  CHROME_UPGRADE:
    "The current chrome version does not support the Screen Share function, please update chrome to version 72 and above.",
  SUPPORT_SHARE_NAME:
    "This browser does not support sharing, please use the latest version of Chrome or Firefox.",
  HOST_UPGRADE: "You have been set as the host of the current meeting.",
  MEEE_ISOVER: "The meeting is over.",
  LEAVE_MEET_BY_HOST: "You are expelled by the host.",
  LEAVE_MEET_ALREADY_NAME: "You have left the meeting.",
  HIDE_SMALL_VIDEO: "Hide",
  SPONSOR_SHARE: "Starting sharing",
  NEW_SHARE_ISRECEIVED:
    " starts a new share, and your share has been automatically stopped.",
  ERASER_NAME: "Eraser",
  CLEAR_MYSELFT_POSTIL: "Clear all my marks",
  DEVICE_OCCUPY:
    "The device you selected is already occupied, please select another device.",
  DEVICE_REJECE:
    "You have banned the current device, please go to the permission settings of your browser to allow use.",
  DEVICE_NOFOUND:
    "No device found, please check if there are available devices on the computer.",
  RECEIVEING_SHARE_TIPS: "Receiving sharing ",
  SPONSOR_SHAERL: "from ",
  CALL_OUT_PARTICIPANT: "Call Participants",
  NO_OTHER_PARTICIPANT: "No other contacts.",
  ASSIGN_PARTICIPANT: "Fix a participant",
  ASSIGN_NAME: "Fix",
  ALREADY_ASSIGN_NAME: "Fixed",
  INPUT_LIMIT_NUMBER:
    "The meeting has reached the maximum number of participants.",
  HANDLE_FAILER_TIPS: "Operation failed, please try again later.",
  ASSIGIN_FAILED: "Failed to fix a participant.",
  OPEN_MUTE_JOINROOM: "Join without audio",
  CLOSE_CAMERA_JOINROOM: "Join without video",
  HOST_LOCK_PLEACE_APPLY_JOINROOM:
    'The meeting is for authorized attendees only. Click “Apply" for the host admission.',
  APPLY_JOINROOM: "Apply",
  AWAIT_APPLY_RESULT: "Please wait, the meeting host will let you in soon.",
  REJECT_ALLPY: "Your application was rejected by the host.",
  MORE_NAME: "More",
  ALREADY_JOIN_ROOM_NAME: "Joined",
  NO_JOIN_ROOM_NAME: "Unjoined",
  MEET_CHAT_NAME: "Chatroom",
  INVITE_PART_NAME: "Invite",
  COPY_INVITE: "Copy Invitation",
  RECORD_NAME: "Record",
  RECORDING_NAME: "Recording",
  OPEN_RECORD_PERMISSION:
    "This function has not been activated, please contact the company administrator.",
  INCREASE_RECORD_SPACE:
    "The storage space is exhausted, please contact the company administrator to recharge.",
  LAYOUT_NAME: "Layout",
  IGNORE_ALL_APPLY_NAME: "Ignore All",
  IGNORE_NAME: "Ignore",
  ALL_IGNORE_NAME: "Ignore All",
  SEARCH_NAME: "Search",
  HOST_NAME: "Host",
  PC_JOIN_ROOM_NAME: "PC Joined",
  WEB_JOIN_ROOM_NAME: "WEB Joined",
  ANDROID_JOIN_ROOM_NAME: "Android Joined",
  TOUCH_JOIN_ROOM_NAME: "Touch Joined",
  BOX_JOIN_ROOM_NAME: "硬件终端入会",
  IOS_JOIN_ROOM_NAME: "iOS Joined",
  APPLY_NAME: "Application",
  TOP_NAME: "Sticky on Top",
  CANCEL_TOP_NAME: "Unstick",
  MORE_HANDLE_NAME: "More",
  SET_VIDEO_LAYOUT_NAME: "Layout settings",
  ONE_WAY_LAYOUT_NAME: "One video",
  TWO_WAY_LAYOUT_NAME: "Two videos",
  THREE_WAY_LAYOUT_NAME: "Three videos",
  FOUR_WAY_LAYOUT_NAME: "Four videos",
  SIX_WAY_LAYOUT_NAME: "Six videos",
  EIGHT_WAY_LAYOUT_NAME: "Eight videos",
  NINE_WAY_LAYOUT_NAME: "Nine videos",
  TEN_WAY_LAYOUT_NAME: "Ten videos",
  THIRTEEN_WAY_LAYOUT_NAME: "Thirteen videos",
  SIXTEEN_WAY_LAYOUT_NAME: "Sixteen videos",
  SANSHI_SECOND_NAME: "30s",
  LIUSHI_SECOND_NAME: "60s",
  JIUSHI_SECOND_NAME: "90s",
  AUTO_LOOPTIME_NAME: "Video Scroll Time",
  LOCK_ROOM_NAME: "Lock Meeting",
  PERMIT_SHARE_NAME: "Allow everyone to share",
  ALREADY_PERMIT_SHARE_NAME: "Participants have been allowed to share.",
  ALREADY_FORBIT_ALL_SHARE_NAME:
    "Participants have been prohibited from sharing.",
  FORBIT_SHARE_NAME: "Prohibited sharing successfully.",
  PERMIT_SHARE_NAM: "Authorized to share successfully.",
  HOST_PERMIT_SHARE_NAME: "You have been allowed to share by host.",
  HOST_FORBIT_SHARE_NAME: "You have been prohibited from sharing by host.",
  MEET_PERMIT_SHARE_NAME: "Participants are allowed to share.",
  MEET_FORBIT_SHARE_NAME: "Participants are prohibited from sharing.",
  FORBIT_PART_SHARE_FAILED: "Failed to forbid participants to share.",
  PERMIT_PART_SAHRE_FAILED: "Failed to allow everyone to share.",
  FORBIT_SHARE_FAILED: "Failed to prohibit sharing.",
  PERMIT_SHARE_FAILED: "Failed to authorize.",
  FORBIT_NOTE_FAILED: "Failed to prohibit marking.",
  PERMIT_NOTE_FAILED: "Failed to allow marking.",
  SPONSOR_SHAERLER_FORBIT_NOTE:
    "Marking is prohibited by the sharing initiator.",
  SPONSOR_SHAERLER_PERMIT_NOTE: "Marking is allowed by the sharing initiator.",
  ALREADY_SELECT_NAME: " participant(s) ",
  PART_NUM_NAME: "selected",
  NO_FOUND_NAME: "No participants found.",
  NO_FOUND_PART: "No related user found...",
  COPY_ROOM_INFO: "Copy Invitation",
  PERMIT_MEET_NAME: "Allow Chat",
  SEND_NAME: "Send",
  ME_NAME: "Me",
  COPY_NAME: "Copy",
  COPY_SUCCESS_NAME: "Copy successfully.",
  COPY_FAILED_NAME: "Copy failed.",
  NO_PART_OR_NO_CAMERA:
    "Cannot find the participant or the participant does not turn on the camera.",
  CALL_MANY_PEOPLE_NAME: "Call Now",
  CANCEL_ALL_CALL_NAME: "Cancel",
  AGREE_NAME: "Admit",
  CANCEL_CALL_NAME: "Cancel Call",
  IS_CANCEL_ALL_NAME: "Do you want to cancel all calls？",
  CALLING_NAME: "(Calling)",
  ALREADY_REJECT_NAME: "(Rejected)",
  BUSYLINE_NAME: "(Busy)",
  ALREADT_CANCEL_NAME: "(Disconnected)",
  ALREADY_LEAVE_NAME: "(Left)",
  NO_RESPONSE_NAME: "(Unanswered)",
  ATONCE_CALL_NAME: "Call Now",
  CALL_FAILED: "Call failed.",
  CANCEL_CALL_FAILED: "Cancel call failed.",
  MEET_NOTICE_NAME: "[Meeting Invitation]",
  CLICK_JOIN_ROOM: "Click to join",
  MEET_TIME: "Meeting Time",
  TRANSFER_HOST_IDENTITY: "Transfer the Host Role",
  CONFIRM_TRANSFER_HOST_IDENTITY: "Do you want to transfer the host role?",
  TRANSFER_HOST_FAILED: "Failed to transfer the host role.",
  SPEAK_APPLY: "Speaking Application",
  HOST_MUTE_APPLY:
    "No speaking allowed in the meeting. Do you want to apply to the host to speak?",
  HOST_MUTE_PART_APPLY:
    "The host has muted you. Do you want to apply to the host to speak?",
  NOTE_NAME: "Mark",
  HOST_CLOSE_ALL_NOTE_POWER: "Share initiator has prohibited marking.",
  CLOSE_MIC_NAME: "Turn off microphone",
  OPEN_MIC_NAME: "Turn on microphone",
  CLOSE_CAMERA_NAME: "Turn off camera",
  OPEN_CAMERA_NAME: "Turn on camera",
  SPEED_NAME: "Bitrate",
  SEND_PACKET_NAME: "Packets sent",
  LOST_PACKET_NAME: "Packet lost",
  LOST_PACKET_RATE_NAME: "Resent Percentage lost",
  RESOLUTION_NAME: "Resolution",
  FRAME_RATE_NAME: "Frame Per Second",
  CODEC_NAME: "Codec",
  DECODE_NAME: "Decoder",
  DECODE_DELAY_NAME: "Decoder delay",
  RECEIVE_PACKET_NAME: "Packets received",
  ENCODED_DELAY_NAME: "Encoder delay",
  VIDEO_SEND_NAME: "Video Out",
  AUDIO_SEND_NAME: "Audio Out",
  SHARE_VIDEO_SEND_NAME: "Share Video Out",
  SHARE_VIDEO_RECEIVE_NAME: "Share Vdeo In",
  SHARE_AUDIO_RECEIVE_NAME: "Share Audio In",
  VIDEO_RECEIVE_NAME: "Video In",
  AUDIO_RECEIVE_NAME: "Audio In",
  CONNECT_SIGNAL: "Media Statistics",
  KPBS_NAMS: "kbps",
  LOADING_NAME: "Loading",
  LOAD_FAILE_NAME: "Loading failed, please try again later.",
  ALREADY_SHOW_ALL_NAMW: "It's all shown…",
  LATERON_SEND_NAME: "Your speech is too fast, please post it later",
  NUM_NEWMSG_TIPS_NAME: "new message(s)",
  BROWSER_COMPATE_TIPS_NAME:
    "The current browser has compatibility issues, please use the latest version of Chrome or Firefox.",
  CHANGE_MIC_DEVICE_NAME: "Select a Microphone",
  CHANGE_SPEAKER_DEVICE_NAME: "Select a Speaker",
  CHANGE_CAMERA_DEVICE_NAME: "Select a Camera",
  OPEN_MAX_RESOLUTION: "The highest resolution activated:",
  ON_OPENED_NAME: "(Nonactivated)",
  CUSTOMER_SERVICE_CALL: "Service Hotline: 400-650-9263",
  ALREADY_PASS_REG: "ISO20000 and ISO27001 Certification Passed",
  ALL_RIGHT_RESERVED: "All Rights Reserved:",
  COMPANY_NAME: "Beijing 263 Enterprise Communication Co., Ltd. ",
  COPYRIGHT_NAME: `Copyright©1998-${new Date().getFullYear()}`,
  ANDROID_NAME: "Android",
  IPHONE_NAME: "iPhone",
  WINDOWS_NAME: "Windows",
  MOBILE_TERMINAL: "Mobile",
  ROOM_FULL_NAME:
    "You can not join for the meeting room is full load, please contact the host or try again later.",
  APPLY_SPEAK: " is applying for speaking",
  APPLY_SHARE: " is applying for sharing",
  SPEAKING: " is speaking",
  PHONE_JOINER: "Phone",
  MEET_SET_FORBIT_CHAT: "Participants are prohibited from chatting.",
  MEET_SET_PERMIT_CHAT: "Participants are allowed to chat.",
  NOT_OPEN_FUNCTIONE:
    "This function has not been activated, please contact the company administrator.",
  PART_WILL_DESTROY_TIPS:
    "Since the host is not in the meeting, the meeting will end in 5 minutes.",
  HOST_WILL_DESTROY_TIPS:
    "Since you are the only person in the meeting, the meeting will end in 5 minutes.",
  APPLY_BUSY: "Your application is too frequent, please try again later.",
  DIAABLE_MIC_CAMERA_TIPS:
    "Unable to connect to the camera or microphone. Please check if your camera or microphone is connected or occupied by other apps.",
  CHANGE_DEVICE_NOT_ALLOWED_TIPSL:
    "The microphone or camera is disabled, please click [Lock] on the left side of the browser address bar to set the camera and microphone to 'Allow'.",
  CHANGE_DEVICE_NOT_READABLE_TIPS:
    "1 Please check whether the camera or microphone is occupied by other software;\n2 Please check Windows system settings—>Privacy—>Camera/Microphone—>Allow apps to access your camera/microphone—>Enable.",
  CHANGE_DEVICE_NOT_FOUND_TIPS:
    "1 Please check whether the camera or microphone is connected normally;\n2 Please check whether the camera or microphone is disabled in the Windows Device Manager.",
  AUTO_LAYOUT: "Auto View",
  LAYOUT_SET_NAME: "Layout",
  EQUAL_SCREEN_LAYOUT: "Gallery View",
  FOCUS_LAYOUT: "Focus View",
  RECOMMEND_NAME: "(Recommend)",
  SELECT_AUTO_LAYOUT: "Change to Auto View?",
  INVITE_REACH_LIMIT_TIPS:
    "The participants you selected exceed the maximum limitation, please select again.",
  PEOPLE_NAME: "people",
  JOINR_NAME: " joined",
  LEAVE_NAME: " left",
  APPLY_MANAGE: "Application Management",
  USER_AGREEMENT: "User Agreement",
  PRIVACY_POLICY: "Privacy Policy",
  MAC_SHARE_PERMISSION_TIPS:
    "您的浏览器没有获得系统的 “屏幕录制”权限，请在【系统偏好设置】—>【安全性与隐私】—>【隐私】—>【屏幕录制】，勾选您所使用的浏览器后，重新发起共享。",
  NET_BAD_TIPS: "Your internet connection is unstable. ",
  WINDOW_INSTALL_HREF: "https://simupdate.263.net/yspcupdate/263Vision.exe",
  IOS_INSTALL_HREF: "https://apps.apple.com/cn/app/id1487354600",
  ANDROID_INSTALL_HREF: "https://simupdate.263.net/ysandroid/263Vision.apk",
  USER_AGREEMENT_HREF: "https://www.263.net/263/agreement/terms/",
  PRIVACY_POLICY_HREF: "https://www.263.net/263/agreement/policy/",
  OFFICIAL_WEBSITE_ADDRESS: "https://www.263.net/",
  CSD_HREF:
    "http://support.263.net/chat/pc_new/index.html?sysNum=27528a014a374aaea723e066795bf0f3&groupId=916e19a715094523a39cf9f7c1a7c1ed",
  CUSTOMER_SERVICE: "Support",
  VISIONINSERT: "Webconf Access",
  PHONEINSERT: "Teleconf Access",
  PLEASE_INPUT_NAME: "Name",
  SYSTEM_NAT_ALLOW_CALL: "System does not allow calls.",
  INPUT_RIGHT_PHONE:
    "The format of the number you entered is incorrect, please refer to the following example input:\nDomestic number input format: mobile phone number/area code fixed phone-extension number mobile phone number\ninput: directly enter the mobile phone number, such as: 136****** **;NLandline number input: area code landline number-extension number, such as: 01083740263-1234. \nInternational number input format: 00+country code+area code+mobile/fixed phone\nfor example: American fixed phone 0013235447799.",
  ALREADY_SELECT_PARTS: "You have selected this participant.",
  USER_NOT_PHONE_CODE: "This user has no phone number.",
  SHOW_MIC_VOICE: "Show Microphone Volume",
  VOICE_STIMULATION: "Active Speaker",
  VOICE_STIMULATION_OPEN_FAIL: "Failed to turn on Active Speaker",
  VOICE_STIMULATION_CLOSE_FAIL: "Failed to turn off Active Speaker",
  MIC_UNUSABLE:
    "The program has detected that your current microphone device is unavailable, please change the device.",
  CAMERA_UNUSABLE:
    "The program has detected that your current camera device is unavailable, please change the device.",
  MIC_AND_CAMERA_UNUSABLE:
    "The program detected that your current microphone and camera device is unavailable, please change the device.",
  ENTER_ROOM: "Join",
  RESOLUTION_TIPS:
    "The resolution you choose is the highest one. If the network or device performance is insufficient, the resolution will be automatically reduced.",
  INVITE_NOW_NAME: "Invite Now",
  ADD_PHONE_NUMBER_NAME: "Add phone number",
  WEBCONF_INVITE_NAME: "Webconf Access",
  TELCONF_INVITE_NAME: "Teleconf Access",
  TELCONF_CODE: "Area Code/Fixed Number/Mobile Number",
  EXTENSION_CODE: "Extension",
  ADD_NAME: "Add",
  AUTO_DEFAULT_NAME: "Auto(Default)",
  CHINESE_NAME: "Chinese",
  ENGLISH_NAME: "English",
  CLOSETIPS: "Close Reminder",
  CALL_VIDEO_MEET: "Videoconf Access",
  ADD_SIP: "SIP number",
  VIDEO_MEET_PASSWORD: "Videoconference passcode:",
  INPUT_NUMBER: "Wrong format, please enter 6~10 numbers",
  CALL: "Call",
  SET_STREM_TO_PEXIP: "Send video",
  SELECT_STREM_TO_PEXIP: "Please set up the video sent back to the Videoconf:",
  JOIN_PEXIP_MEET_CONTROL: "Videoconf Control",
  CHANGE: "Switch",
  PASSCODE_INVALID: "Invalid passcode",
  ALREADT_HANGUP: "You have been hung up by the videoconf",
  REMARKES_VIDEO_MEET:
    "Note: If the selected participant closes the video or leaves the meeting, it will automatically switch to the mixed video.",
  MEET_VIDEO: "Mixed Video",
  VIDEO_MEET: "Videoconference",
  LIVE_NAME: "Live",
  REGAIN_HOST_PRIVILEG: "Regain host privileges",
  JOIN_INVITE: "Invitation",
  NOTMUTE: "Mute Videoconference is not supported",
  SET_STREAM_TO_PEXIP_YES: "Switch successfully.",
  SET_STREAM_TO_PEXIP_NO: "Switch failed.",
  SERVER_ERROR: "Network Error, please try again.",
  NET_ERROR: "NET_ERROR",
  JOIN_ROOM_ADDR: "The Participants URL",
  HOST_JOIN_ROOM_ADDR: "The Host URL",
  SCANQR_JOIN_ROOM: "Scan to join",
  NOT_CONTAIN_HOST_URL: "The information does not contain the host URL.",
  LIVE_NAME: "Live",
  OLD_HOST_PASSWORD:
    " joined the meeting by the host URL and has become the host of the meeting.",
  RETRIEVE_HOST: " has regain host privileges.",
  JOINER_URL: "The Host URL",
  HOST_URL: "The Participants URL",
  RECEOVE_HOST_ERR:
    "Failed to regain host privileges, if you need it, please use the host URL to rejoin.",
  INVITE_SEARCH: "Please enter name, phone number or ID",
  CALL_PHONE_CONTENT:
    "Enter your phone number to add a member.After adding,then click OK to call",
  GOON_ADD: "Add more",
  INVITE: "Invite",
  NO_DATA: "No data",
  ASSIGIN: "Set as",
  SHARE_DOC: "Doc Window",
  SHARE_SCREEN: "Sharing Window",
  MIX: "Video Window",
  ALLOW_MOTIFY_NAME: "Allow renaming",
  MOTIFY_NAME: "Edit Name",
  INPUT_NAME: "Input Name",
  JOIN_MEET_CONTROL: "Meeting Helper",
  SEARCH_RESULT: "Search info.",
  SEPAK_SOMEING: "Input some thing happy…",
  NOT_MEET_CONTENT: "No chat messages",
  VIDEO_JOIN_MEET: "Video Conference Info.",
  PHONE_JOIN_MEET: "Teleconference Info.",
  LIVE_VIEW: "Live view Info.",
  HOST_JOIN_PSD: "Host Passcode:",
  CONFERREEN_JOIN_PSD: "Guest Passcode:",
  ACCESS_NUMBER: "Access No.:",
  OVERSEAS_ACCESS_NUMBER: "More",
  LIVE_THEME: "Live topic",
  LIVE_VIEW_ADDR: "Live address",
  SAVE_QRCODE: "Click to save Pic.",
  DOC_SHARE: "Doc Sharing",
  MEET_IS_LOCK: "Meeting Locked",
  OVERSEAS_ACCESS_NUMBER_SRC: "https://download.263.net/access/",
  PARTY_NUMBER_REPEAT: "Duplicate phone number",
  MOTIFY_ERR: "Failed to edit",
  EXIT_LINK: "New contacts need to add",
  NOT_ADD: "Not to add",
  CONTINUE_ADD: "Add more",
  SHARE_END: "closed Sharing Doc",
  NOT_PARTIES: "No participants",
  PARTIES_ISLEAVE: "The participants have left",
  VIDEO_ISCLOSEL: "Video Closed",
  PART_SEARCH: "Search name, phone number or ID",
  MEET_DURATION: "Meeting duration",
  PLEASE_INPUT_RIGHT_PHONE_NUMBER: "Please enter right phone number",
  HOST_END_SHARE_TIPS: "主持人结束了共享，您的共享已自动退出",
  HOST_HANGUP: "Hung up by the host",
  PARTICIPANT_HANGUP: "Hung up by the participant",
  SYSTEM_NOT_ALLOW_CALL: "System does not allow calls.",
  MIN_NAME: "Min",
  DOUBLE_SCREEN_TIPS:
    "Turning on the dual sharing mode will occupy participants‘s high hardware equipment performance . Are you sure to turn it on？",
  INTERCUT_SHARE: "Shared spot",
  PAUSE_PLAY: "Shared spot",
  START_PLAY: "start",
  YOU_SHARING_INTERCUT: "You are sharing",
  STOP_SHARE: "end",
  SHARING_INTERCUT: "Sharing episode",
  LIST_LOOP: "A list of circulation",
  SINGLE_LOOP: "A single cycle",
  SINGLE_PLAY: "A single play",
  ALREADY_FIRST: "It's already the first！",
  ALREADY_LAST: "It's the last one！",
  MOVE_NAME: "Drag",
  PRE_NAME: "the previous",
  NEXT_NAME: "the next",
  LIST_NAME: "list",
  PLEASE_INPUT_SIP_CODE: "Enter the SIP number",
  CAST_SCREEN: "Cast Screen",
  REPORT_PHONE: "Report Tel:",
  REPORT_EMAIL: "Report Mail:",
  GROUP_DISCUSS: "Group Discussion",
  CREATE_NAME: "Create",
  RANDOM_DISTRIBUTION: "Random Allocation",
  MANUAL_DISTRIBUTION: "Manual Assignment",
  PRE_DISTRIBUTION: "Use Pre-set groups",
  PRE_DISTRIBUTIONTIPS: "Use the pre-set groups of this meeting",
  GROUP_NUMBER: "Number of discussion groups",
  GROUP_MEMBER: "Discussion group members",
  GROUP_TIPS: "This meeting supports up to 15 groups",
  GROUP_TIPSPRE: "You can modify the groups after created",
  RANDOM_TIPS: "Distribute participants equally to discussion group",
  MANUAL_TIPS: "The host manually assigned participants to each group",
  ALLOW_FREE_SELECT: "Allow participants to choose freely",
  NEED_AGREE_JOINED: "Join the group after the participants agree",
  PLEASE_INPUT_RIGHT_NUMBER: "Please enter the correct number",
  RECREATE: "Recreate",
  ADD_DISCUSS: "Add discussion group",
  START_DISCUSS: "Begin discussion",
  DISTRIBUTION: "Assign",
  GROUP_HOST: "Group Host",
  SET_GROUP_HOST: "Set group host",
  MOVE_TO: "Move to",
  DELETE: "Delete",
  RENAME: "Rename",
  IS_CONFIRME_DELETE_GROUP:
    "Are you sure to delete the current discussion group?",
  NO_DISTRIBUTION: "Unassigned",
  NO_START: "Not started",
  ONGOING: "In progress",
  RE_CREATE_TIPS: "All created discussion groups will be replaced",
  NO_JOINER: "Not joined",
  ISLEAVE: "Has left",
  ALREADY_JOINED: "Joined",
  JOINED: "Join",
  EDN_DISCUSS: "End Discussion",
  SEND_ALL_MSG: "Send all messages",
  JOIN_DISTRIBUTION: "Join the discussion group",
  HOST_INVITE_YOU: "The host invites you to join",
  PLEASE_HELP: "Request Help",
  YOU_CAN_PLEASE_HELP: "You can invite the host to join the group to help",
  POST_MSG_TO_ALL_TEAM: "Send a message to all discussion groups…",
  CHANGE_TEAM_HOST: "Change group host",
  CHANGE_TEAM_HOST_TISP:
    "Whether to set the current participant as the group host, and replace the former group host after confirmation",
  LEAVE_TEAM: "Leave the discussion group",
  END_NAME: "End",
  IS_END: "Are you sure to end the group discussion？",
  END_SELECT:
    "Keep the previous group configuration after finishing and start again quickly",
  BACK_MAIN: "Return to main meeting",
  BACK_MAIN_OR_LEAVE:
    "You can return to the main meeting or leave the meeting directly",
  YOUR_BACK_MAIN: "You are returning to the main meeting",
  YOUR_JOIN_TEAM: "You are entering the branch meeting",
  TEAM_END_OR_YOUR_BACK_MAIN:
    "The group discussion has ended,you are returning to the main meeting",
  NO_DIVIDE_INTO_GROUP_USER: "Ungrouped members",
  NO_DIVIDE_USER: "No assignable participants",
  HOST_BUSY: "The host is busy, please try again later",
  HOST_CANCEL: "The host has canceled your status as a group host",
  CHANGE_TEAM: "The host has moved you to",
  YOU_SET_TEAM_HOST: "You have been set as a group host",
  MAIN_TEAM: "Main meeting",
  DELETE_ERROR: "Failed to delete,at least one discussion group is required",
  PLEASE_INPUT_RIGHT_GROUP_NUMBER: "Please enter the correct number of groups",
  NO_GROUP_POWER: "No grouping permission, please contact the administrator",
  SET_SUCCESS: "Setting succeeded",
  LATER: "Later",
};
export default en_us;
